// extracted by mini-css-extract-plugin
module.exports = {"mainMessage":"SelectAccount_mainMessage__M2cCB","loginMessage":"SelectAccount_loginMessage__sU_Is","button":"SelectAccount_button__RobNV"};